<template>
<v-row style="margin-top: 64px" justify="center">
    <v-flex xs12 lg7 class="px-2">
      <v-card>
        <v-toolbar class="deep-orange" dark>
          <v-toolbar-title>Kontakte</v-toolbar-title>
          <v-spacer></v-spacer>


        <v-menu bottom left>
            <template v-slot:activator="{on}" >
                <v-btn icon="icon" dark v-on="on">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
            </template>
            <v-list>
              <v-list-item :to="{name: 'contactNew'}">
                <v-list-item-title><v-icon>mdi-account-plus</v-icon></v-list-item-title>
              </v-list-item>
              <v-list-item @click="autoContact('servSoc')">
                <v-list-item-title>Sozialdienst</v-list-item-title>
              </v-list-item>
              <v-list-item @click="autoContact('servCur')">
                <v-list-item-title>Kuratorendienst</v-list-item-title>
              </v-list-item>
              <v-list-item @click="autoContact('PFB')">
                <v-list-item-title>PF Brulhart et Fils</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

        </v-toolbar>
        <v-list two-line>
          <template>
              <v-list-item @click.stop="showContact(contact.id)" v-for="(contact, i) in contacts" :key="i">
                  <div class="text-center" style="width: 250px">
                    <v-chip outlined :color="contact.sexe == 'Masculin' ? 'blue': 'pink'">
                        <v-icon :class="contact.sexe == 'Masculin' ? 'blue--text': 'pink--text'">mdi-account</v-icon>
                        <v-icon v-if="contact.facture==true" class="green--text">mdi-currency-usd</v-icon>
                        <v-icon v-if="contact.legal==true" class="purple--text">mdi-gavel</v-icon>
                        <v-icon v-if="contact.celebrant==true" class="orange--text">mdi-flare</v-icon>
                        {{contact.designation}}
                    </v-chip>
                  </div>
                <v-list-item-content>
                  <v-list-item-title v-html="contact.prenom + ' ' + contact.nom"></v-list-item-title>
                  <v-list-item-subtitle v-html="contact.cp + ' ' + contact.loc + ' - ' + contact.adresse + ' / tél. <strong>' + contact.tel1 + '</strong>'"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <div>
                        <v-btn fab small color="primary" dark :to="{name: 'contactEdit', params: {idContact: contact.id}}">
                        <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn fab small color="error" dark @click.stop="askDeleteContact(contact.id)">
                        <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </div>
                  </v-list-item-action>
              </v-list-item>
          </template>
        </v-list>
      </v-card>
    </v-flex>
    <v-flex class="px-2" xs12 lg5 v-if="typeof(contactsCult.lieu) !== 'undefined'">
      <v-card>
        <v-toolbar class="brown" dark>
          <v-toolbar-title>Pfarramt</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <p class="text-lg-h6">{{"Cérémonie " + contactsCult.lieu + " de " + contactsCult.localite}}</p>
        </v-card-text>
        <v-list two-line>
            <v-list-item-group>
            <v-list-item :href="'tel:' + contactsCult.tel_secretar" v-if="contactsCult.tel_secretar !==''">
              <v-list-item-icon>
                <v-icon>mdi-phone</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{contactsCult.tel_secretar}}</v-list-item-title>
                <v-list-item-subtitle>Secrétariat</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :href="'tel:' + contactsCult.tel_sacristain" v-if="contactsCult.tel_sacristain !==''">
              <v-list-item-icon>
                <v-icon>mdi-phone</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{contactsCult.tel_sacristain}}</v-list-item-title>
                <v-list-item-subtitle>Sacristain</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :href="'tel:' + contactsCult.tel_urgence" v-if="contactsCult.tel_urgence !==''">
              <v-list-item-icon>
                <v-icon>mdi-phone</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{contactsCult.tel_urgence}}</v-list-item-title>
                <v-list-item-subtitle>Urgence</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :href="'mailto:' + contactsCult.mail_paroisse" v-if="contactsCult.mail_paroisse !==''">
              <v-list-item-icon>
                <v-icon>mdi-email</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{contactsCult.mail_paroisse}}</v-list-item-title>
                <v-list-item-subtitle>E-mail de la paroisse</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
        </v-list-item-group>
        </v-list>
      </v-card>
    </v-flex>
    <v-dialog v-model="dialog" absolute max-width="480">
      <v-card>
        <v-card-title>
          <div class="headline">
            <span v-if="contact.titre !== null">{{contact.titre + " "}}</span>
            <span>{{contact.prenom + " " + contact.nom}}</span>
            <p>{{contact.adresse}}</p>
            <p>{{contact.cp + ' ' + contact.loc}}</p>
            <div class="text-center">
                <v-chip outlined :color="contact.sexe == 'Masculin' ? 'blue': 'pink'">
                    <v-icon :class="contact.sexe == 'Masculin' ? 'blue--text': 'pink--text'">mdi-account</v-icon>
                    {{contact.designation}}
                </v-chip>
                <v-icon v-if="contact.facture==true" class="green--text">mdi-currency-usd</v-icon>
                <v-icon v-if="contact.legal==true" class="purple--text">mdi-gavel</v-icon>
                <v-icon v-if="contact.celebrant==true" class="orange--text">mdi-flare</v-icon>
            </div>
          </div>
        </v-card-title>
        <v-card-text>
            <v-list two-line>
                <v-list-item :href="'tel:' + contact.tel1" v-if="contact.tel1 !=''">
                    <v-list-item-action>
                        <v-icon class="indigo--text">mdi-phone</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{contact.tel1}}</v-list-item-title>
                        <v-list-item-subtitle>Telefonnummer 1</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :href="'tel:' + contact.tel2" v-if="contact.tel2 !=''">
                    <v-list-item-action>
                        <v-icon class="indigo--text">mdi-phone</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{contact.tel2}}</v-list-item-title>
                        <v-list-item-subtitle>Telefonnummer 2</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider inset></v-divider>
                <v-list-item :href="'mailto:' + contact.mail1" v-if="contact.mail1 !=''">
                    <v-list-item-action>
                        <v-icon class="indigo--text">mdi-email</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{contact.mail1}}</v-list-item-title>
                        <v-list-item-subtitle>E-mail 1</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :href="'mailto:' + contact.mail2" v-if="contact.mail2 !=''">
                    <v-list-item-action>
                        <v-icon class="indigo--text">mdi-email</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{contact.mail2}}</v-list-item-title>
                        <v-list-item-subtitle>E-mail 2</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDel" absolute max-width="400px">
      <v-card>
        <v-card-title>
          <div class="headline">Kontakt löschen ?</div>
        </v-card-title>
        <v-card-text>{{contact.prenom + ' ' + contact.nom}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="green--text darken-1" text @click.native="dialogDel = false">Abbrechen</v-btn>
          <v-btn :loading="delLoad" :disabled="delLoad" class="red--text darken-1" text @click.native="deleteContact(contact.id)">Supprimer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
    import {ajax_post} from '../../public/global.js'
    export default {
        data(){
            return{
                contacts: [],
                contact: {
                    sexe: '',
                    designation: '',
                    titre: '',
                    prenom: '',
                    nom: '',
                    adresse: '',
                    cp: '',
                    localite: '',
                    tel1: '',
                    tel2: '',
                    mail1: '',
                    mail2: '',
                    remarque: '',
                    facture: '',
                    soussign: ''
                },
                contactsCult: {},
                loading: false,
                dialog: false,
                dialogDel: false,
                delLoad: false
            }
        },
        methods: {
            fetchData () {
                ajax_post(`/PHP/ajax/returnContacts.php`,`id=${this.$route.params.id}&token=${this.$token()}`).then((response) =>{             
                    let rep = JSON.parse(response)
                    if(!rep.error){
                        rep.data.contacts.forEach(elem =>{
                            if(elem.cp == null){
                                elem.cp = ""
                            }
                        })
                        this.contacts = rep.data.contacts
                        this.contactsCult = rep.data.contactsCult
                    }else{
                      this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                    }
                })
            },
            deleteContact(id) {
                this.delLoad = true
                ajax_post(`/PHP/ajax/deleteContact.php`, `id=${id}&token=${this.$token()}`).then((response) =>{
                    let rep = JSON.parse(response)
                    if(!rep.error){
                        this.dialogDel = false
                        this.delLoad = false
                        this.$root.$emit('myinfo', {title: "Serenity", msg: "Contact supprimé !", color: ""})
                        this.fetchData()
                    }else{
                      this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                    }
                })
            },
            findIndexById(id) {
                for(let i = 0; i < this.contacts.length; i++){
                    if(this.contacts[i].id == id){
                        return i
                    }
                }
            },
            showContact(id) {
                let indexClicked = this.findIndexById(id)

                this.contact.sexe = this.contacts[indexClicked].sexe
                this.contact.designation = this.contacts[indexClicked].designation
                this.contact.titre = this.contacts[indexClicked].titre
                this.contact.prenom = this.contacts[indexClicked].prenom
                this.contact.nom = this.contacts[indexClicked].nom
                this.contact.adresse = this.contacts[indexClicked].adresse
                this.contact.cp = this.contacts[indexClicked].cp
                this.contact.loc = this.contacts[indexClicked].loc
                this.contact.tel1 = this.contacts[indexClicked].tel1
                this.contact.tel2 = this.contacts[indexClicked].tel2
                this.contact.mail1 = this.contacts[indexClicked].mail1
                this.contact.mail2 = this.contacts[indexClicked].mail2
                this.contact.remarque = this.contacts[indexClicked].remarque
                this.contact.facture = this.contacts[indexClicked].facture
                this.contact.legal = this.contacts[indexClicked].legal
                this.contact.celebrant = this.contacts[indexClicked].celebrant
                this.dialog = true
            },
            askDeleteContact(id) {
                let indexClicked = this.findIndexById(id)
                this.contact.id = this.contacts[indexClicked].id
                this.contact.titre = this.contacts[indexClicked].titre
                this.contact.prenom = this.contacts[indexClicked].prenom
                this.contact.nom = this.contacts[indexClicked].nom
                this.dialogDel = true
            },
            autoContact(choice) {
                ajax_post(`/PHP/ajax/autoContact.php`, `id=${this.$route.params.id}&token=${this.$token()}&choice=${choice}`).then((response)=>{
                    let rep = JSON.parse(response)
                    if(!rep.error){
                        this.fetchData()
                    }else{
                        this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                    }
                })
            }
        },
        created() {
            this.fetchData()
        }
    }
</script>